export const filterInitialState = {
  sortColumn: 'engagementDate',
  sortOrder: 'descend',
};
